"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ToggleSwitchField = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var uuid_1 = require("uuid");
var Primitives_1 = require("../Primitives");
var ToggleSwitchField_module_scss_1 = __importDefault(require("./ToggleSwitchField.module.scss"));
/**
 * {@link https://cultureamp.design/components/toggle-switch-field/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-form-toggle-switch-field--default Storybook}
 */
var ToggleSwitchField = function (_a) {
    var propsId = _a.id, labelText = _a.labelText, _b = _a.labelPosition, labelPosition = _b === void 0 ? "start" : _b, toggledStatus = _a.toggledStatus, disabled = _a.disabled, reversed = _a.reversed, inline = _a.inline, fullWidth = _a.fullWidth, restProps = __rest(_a, ["id", "labelText", "labelPosition", "toggledStatus", "disabled", "reversed", "inline", "fullWidth"]);
    var id = (0, react_1.useState)(propsId || (0, uuid_1.v4)())[0];
    return (react_1["default"].createElement(Primitives_1.FieldGroup, { id: "".concat(id, "-field-group"), inline: inline, automationId: "".concat(id, "-field-group"), classNameOverride: (0, classnames_1["default"])(ToggleSwitchField_module_scss_1["default"].container, fullWidth && ToggleSwitchField_module_scss_1["default"].fullWidth, toggledStatus === Primitives_1.ToggledStatus.ON && ToggleSwitchField_module_scss_1["default"].on) },
        react_1["default"].createElement("div", { className: ToggleSwitchField_module_scss_1["default"].inner },
            react_1["default"].createElement(Primitives_1.Label, { id: "".concat(id, "-field-label"), htmlFor: "".concat(id, "-field-toggle"), automationId: "".concat(id, "-field-label"), labelText: labelText, labelType: "toggle", labelPosition: labelPosition, disabled: disabled, reversed: reversed },
                react_1["default"].createElement(Primitives_1.ToggleSwitch, __assign({ id: "".concat(id, "-field-toggle"), automationId: "".concat(id, "-field-toggle"), disabled: disabled, reversed: reversed, toggledStatus: toggledStatus }, restProps))))));
};
exports.ToggleSwitchField = ToggleSwitchField;
exports.ToggleSwitchField.displayName = "ToggleSwitchField";
//# sourceMappingURL=ToggleSwitchField.js.map